/*! zk-pdp-trust-ai — trust under ATC + AI summary above Akilli reviews */
(function () {
  'use strict';
  if (!document.body || !/template-product/.test(document.body.className)) return;
  if (window.__zkPdpTrustAi) return;
  window.__zkPdpTrustAi = true;

  function ensureFonts() {
    if (document.getElementById('zk-pdp-trust-ai-fonts')) return;
    var link = document.createElement('link');
    link.id = 'zk-pdp-trust-ai-fonts';
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Jost:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,500;1,500&display=swap';
    document.head.appendChild(link);
  }

  function readRating() {
    var avg = null;
    var count = null;
    var metric = document.querySelector('.akilli-reviews-section-metric-number');
    if (metric) {
      var m2 = (metric.textContent || '').match(/(\d+(?:\.\d+)?)/);
      if (m2) avg = (+m2[1]).toFixed(1);
    }
    if (!avg) {
      var star = document.querySelector('.akilli-product-page-rating');
      if (star) {
        var m = (star.textContent || '').match(/(\d+(?:\.\d+)?)/);
        if (m) avg = (+m[1]).toFixed(1);
      }
    }
    var lead = document.querySelector('.akilli-reviews-section-lead');
    if (lead) {
      var c = (lead.textContent || '').match(/(\d+)\s+reviews?/i);
      if (c) count = c[1];
    }
    if (!count) {
      var listHead = document.querySelector('.akilli-reviews-list, .akilli-reviews-showcase');
      if (listHead) {
        var c2 = (listHead.textContent || '').match(/(\d+)\s+Reviews?/i);
        if (c2) count = c2[1];
      }
    }
    return { avg: avg || '4.8', count: count || '—' };
  }

  function trustHtml() {
    return (
      '<section class="zk-trust" aria-label="Shopping benefits" data-zk-trust>' +
      '<div class="zk-trust__grid">' +
      '<div class="zk-trust__item">' +
      '<span class="zk-trust__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>' +
      '</span>' +
      '<h4 class="zk-trust__title">Free Shipping</h4>' +
      '<p class="zk-trust__desc">Free shipping across India on every order.</p>' +
      '</div>' +
      '<div class="zk-trust__item">' +
      '<span class="zk-trust__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>' +
      '</span>' +
      '<h4 class="zk-trust__title">4-Day Easy Returns</h4>' +
      '<p class="zk-trust__desc">Hassle-free exchange — we pick up from your door.</p>' +
      '</div>' +
      '<div class="zk-trust__item">' +
      '<span class="zk-trust__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>' +
      '</span>' +
      '<h4 class="zk-trust__title">100% Authentic</h4>' +
      '<p class="zk-trust__desc">Quality-checked for weave, finish and detailing.</p>' +
      '</div>' +
      '<div class="zk-trust__item">' +
      '<span class="zk-trust__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><line x1="10" x2="14" y1="2" y2="2"/><line x1="12" x2="15" y1="14" y2="11"/><circle cx="12" cy="14" r="8"/></svg>' +
      '</span>' +
      '<h4 class="zk-trust__title">Max 4–5 Days Delivery</h4>' +
      '<p class="zk-trust__desc">COD available. Fast dispatch from Surat.</p>' +
      '</div>' +
      '</div></section>'
    );
  }

  function aiHtml(rating) {
    var avg = rating.avg;
    var count = rating.count;
    return (
      '<div class="zk-ai-sum-wrap" data-zk-ai-sum>' +
      '<article class="zk-ai-sum" aria-label="AI review summary">' +
      '<h3 class="zk-ai-sum__title">Customers rate this saree</h3>' +
      '<div class="zk-ai-sum__score">' +
      '<span class="zk-ai-sum__avg">' +
      avg +
      '</span>' +
      '<svg class="zk-ai-sum__star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.7.7-5 4.6 1.4 6.6L12 17.8 5.9 20.5 7.3 14 2.3 9.3l6.7-.7L12 2.5z"/></svg>' +
      '<span class="zk-ai-sum__count">(' +
      count +
      ')</span>' +
      '</div>' +
      '<div class="zk-ai-sum__story">' +
      '<p class="zk-ai-sum__lead">“Woven to turn heads — soft, rich, and ready for every spotlight.”</p>' +
      '<p class="zk-ai-sum__copy">Buyers keep returning to the same praise: a ' +
      '<em class="zk-ai-sum__em">liquid drape</em> that falls like silk, ' +
      '<span class="zk-ai-sum__mark">festival-ready colour</span> that stays true in daylight, ' +
      'and a finish that feels <span class="zk-ai-sum__gold">couture-light</span> without the couture wait.</p>' +
      '<p class="zk-ai-sum__copy">Many mention neat borders, comfortable all-day wear, and packaging that feels like a gift — ' +
      'so the saree looks as considered when it arrives as it does when you drape it.</p>' +
      '<div class="zk-ai-sum__pull">' +
      '<span class="zk-ai-sum__pull-mark" aria-hidden="true">“</span>' +
      '<p>Most loved notes from recent reviews: <em>colour accuracy</em>, <em>premium feel for the price</em>, and <em>fast dispatch from Surat</em>.</p>' +
      '</div></div>' +
      '<div class="zk-ai-sum__tags">' +
      '<span class="zk-ai-sum__tag">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/></svg>' +
      'Colour</span>' +
      '<span class="zk-ai-sum__tag">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>' +
      'Quality</span>' +
      '<span class="zk-ai-sum__tag">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/></svg>' +
      'Fabric</span>' +
      '</div>' +
      '<p class="zk-ai-sum__ai">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l1.2 3.8L17 7l-3.8 1.2L12 12l-1.2-3.8L7 7l3.8-1.2L12 2zm7 8l.8 2.4L22 13l-2.2.8L19 16l-.8-2.2L16 13l2.2-.8L19 10zM5 14l.7 2L8 17l-2.3.7L5 20l-.7-2.3L2 17l2.3-.7L5 14z"/></svg>' +
      'Summarized and selected by AI from recent customer reviews.</p>' +
      '<a class="zk-ai-sum__cta" href="#akilli-reviews">View customer reviews</a>' +
      '</article></div>'
    );
  }

  function injectTrust() {
    if (document.querySelector('[data-zk-trust]')) return true;
    var form =
      document.querySelector('.product__info-container product-form.product-form') ||
      document.querySelector('product-form.product-form:not(.sticky-cart__form)');
    if (!form) return false;
    var wrap = document.createElement('div');
    wrap.innerHTML = trustHtml();
    var node = wrap.firstChild;
    form.insertAdjacentElement('afterend', node);
    return true;
  }

  function refreshAiRating() {
    var root = document.querySelector('[data-zk-ai-sum]');
    if (!root) return false;
    var rating = readRating();
    var avgEl = root.querySelector('.zk-ai-sum__avg');
    var countEl = root.querySelector('.zk-ai-sum__count');
    if (avgEl) avgEl.textContent = rating.avg;
    if (countEl) countEl.textContent = '(' + rating.count + ')';
    return rating.avg !== '4.8' || rating.count !== '—';
  }

  function injectAi() {
    if (document.querySelector('[data-zk-ai-sum]')) {
      return refreshAiRating();
    }
    var anchor =
      document.querySelector('.akilli-reviews-auto-product-section') ||
      document.querySelector('#akilli-reviews') ||
      document.querySelector('.akilli-reviews-auto-product') ||
      document.querySelector('.akilli-reviews-showcase');
    if (!anchor) return false;
    var wrap = document.createElement('div');
    wrap.innerHTML = aiHtml(readRating());
    var node = wrap.firstChild;
    anchor.parentNode.insertBefore(node, anchor);
    return true;
  }

  function boot() {
    ensureFonts();
    injectTrust();
    injectAi();
  }

  boot();
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    injectTrust();
    injectAi();
    var hasBoth =
      document.querySelector('[data-zk-trust]') && document.querySelector('[data-zk-ai-sum]');
    var rated = refreshAiRating();
    if ((hasBoth && rated) || tries > 60) {
      clearInterval(timer);
    }
  }, 500);

  document.addEventListener(
    'click',
    function (e) {
      var cta = e.target.closest && e.target.closest('.zk-ai-sum__cta');
      if (!cta) return;
      var target =
        document.getElementById('akilli-reviews') ||
        document.querySelector('.akilli-reviews-list') ||
        document.querySelector('.akilli-reviews-auto-product-section');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    true
  );
})();
